import type { ChipTone } from "@ui/Atoms/Chip/Chip";
import { Chip } from "@ui/Atoms/Chip/Chip";
import { IconInstagram } from "@ui/Icons/IconInstagram";
import { IconSubstack } from "@ui/Icons/IconSubstack";
import { IconTiktok } from "@ui/Icons/IconTiktok";
import { IconYoutube } from "@ui/Icons/IconYoutube";

export type SocialPlatform = "instagram" | "tiktok" | "youtube" | "substack";

export type SocialLink = {
	platform: SocialPlatform;
	href: string;
	/** Visible label; the caller supplies the (translated) text. */
	label: string;
};

export const SOCIAL_PLATFORM_ICON: Record<
	SocialPlatform,
	typeof IconInstagram
> = {
	instagram: IconInstagram,
	tiktok: IconTiktok,
	youtube: IconYoutube,
	substack: IconSubstack,
};

export const SOCIAL_PLATFORM_LABEL: Record<SocialPlatform, string> = {
	instagram: "Instagram",
	tiktok: "TikTok",
	youtube: "YouTube",
	substack: "Substack",
};

const ICON_COLOR: Record<SocialPlatform, string> = {
	instagram: "var(--chip-instagram-fg)",
	tiktok: "var(--chip-tiktok-fg)",
	youtube: "var(--chip-youtube-fg)",
	substack: "var(--chip-substack-fg)",
};

type Props = {
	links: SocialLink[];
	size?: "sm" | "md";
	onNewsletter?: () => void;
};

export function SocialChips({ links, size = "md", onNewsletter }: Props) {
	return (
		<div className="flex flex-wrap gap-2">
			{links.map(({ platform, href, label }) => {
				const Icon = SOCIAL_PLATFORM_ICON[platform];
				const isSubstack = platform === "substack";
				return (
					<a
						key={platform}
						href={href}
						target="_blank"
						rel="noopener noreferrer"
						onClick={
							isSubstack && onNewsletter
								? (e) => {
										e.preventDefault();
										onNewsletter();
									}
								: undefined
						}
					>
						<Chip
							as="span"
							tone={platform as ChipTone}
							size={size}
							label={label}
							icon={<Icon size={14} color={ICON_COLOR[platform]} />}
						/>
					</a>
				);
			})}
		</div>
	);
}
